import { FC, useContext, useState } from "react";

import "slick-carousel/slick/slick.css";

import { ReactComponent as AddedItem } from "@/globals/images/addedItem.svg";
import { ReactComponent as AddItem } from "@/globals/images/addItem.svg";
import ProductPlaceholder from "@/globals/images/productPlaceholder.png";

import Styles from "./styles.module.scss";
import { TRecommendationCard } from "./interfaces";
import LocaleText from "@/components/Intl/LocaleText";
import Button from "../Button";
import { formatPriceForDisplay } from "@/helpers/price";
import { LocaleContext } from "@/providers/LocaleProvider";
import { PRICE_FORMAT_OPTIONS } from "@/helpers/constants";

const RecommendationCard: FC<TRecommendationCard> = ({
  id,
  name,
  description,
  brand,
  className,
  isVisible = true,
  image_url,
  isActive = false,
  isInCart = false,
  onSelect = () => {},
  price,
  reducedPrice,
}) => {
  const { locale } = useContext(LocaleContext);
  const [initialSelect, setInitialSelect] = useState(true);

  return (
    <div
      className={`${Styles.recommendationCardContainer}${
        className ? ` ${className}` : ""
      }`}
      data-id={id}
    >
      <div
        className={`${Styles.recommendationCard}${
          isActive ? ` ${Styles["recommendationCard--active"]}` : ""
        }${isVisible ? ` ${Styles["recommendationCard--visible"]}` : ""}${
          isInCart ? ` ${Styles.recommendationCard__inCart}` : ""
        }`}
      >
        <div
          className={`${Styles.recommendationCard__visual}${
            isInCart ? ` ${Styles.recommendationCard__visual__cart}` : ""
          }`}
        >
          <img
            src={image_url ? image_url : ProductPlaceholder}
            className={Styles["recommendationCard__visual-image"]}
            alt="card_visual"
          />
        </div>
        <div className={Styles.recommendationCard__content}>
          <p
            className={`${Styles.recommendationCard__title}${
              isInCart ? ` ${Styles.recommendationCard__title__inCart}` : ""
            }`}
          >
            {name}
          </p>
          <p className={Styles.recommendationCard__brand}>{brand?.name}</p>
          {!isInCart && (
            <p
              dangerouslySetInnerHTML={{ __html: description }}
              className={Styles.recommendationCard__description}
            ></p>
          )}
        </div>
        {isInCart && price !== null && (
          <div className={Styles.recommendationCard__cartPriceContainer}>
            {reducedPrice !== null && (
              <p className={Styles.recommendationCard__originalPrice}>
                {formatPriceForDisplay(
                  (price / 100).toLocaleString(locale, PRICE_FORMAT_OPTIONS),
                )}
              </p>
            )}
            <p className={Styles.recommendationCard__finalPrice}>
              {reducedPrice !== null
                ? formatPriceForDisplay(
                    (reducedPrice / 100).toLocaleString(
                      locale,
                      PRICE_FORMAT_OPTIONS,
                    ),
                  )
                : formatPriceForDisplay(
                    (price / 100).toLocaleString(locale, PRICE_FORMAT_OPTIONS),
                  )}
            </p>
          </div>
        )}
        {!isInCart ? (
          <div
            className={`${Styles.recommendationCard__footer} ${
              price === null
                ? Styles.recommendationCard__noPriceAlignement
                : null
            }`}
          >
            {price !== null && (
              <div>
                {reducedPrice !== null && (
                  <p className={Styles.recommendationCard__originalPrice}>
                    {formatPriceForDisplay(
                      (price / 100).toLocaleString(
                        locale,
                        PRICE_FORMAT_OPTIONS,
                      ),
                    )}
                  </p>
                )}
                <p className={Styles.recommendationCard__finalPrice}>
                  {reducedPrice !== null
                    ? formatPriceForDisplay(
                        (reducedPrice / 100).toLocaleString(
                          locale,
                          PRICE_FORMAT_OPTIONS,
                        ),
                      )
                    : formatPriceForDisplay(
                        (price / 100).toLocaleString(
                          locale,
                          PRICE_FORMAT_OPTIONS,
                        ),
                      )}
                </p>
              </div>
            )}

            <Button
              className={Styles.recommendationCard__button}
              onClick={() => {
                onSelect(
                  id,
                  name,
                  initialSelect,
                  !isActive,
                  undefined,
                  image_url,
                );
                setInitialSelect(false);
              }}
              outline={!isActive}
            >
              {isActive ? (
                <>
                  <AddedItem />
                  <div
                    className={`${Styles.recommendationCard__buttonText} ${Styles["recommendationCard__buttonText-active"]}`}
                  >
                    <LocaleText>
                      page.recommendationStep.selectButton.selected
                    </LocaleText>
                  </div>
                </>
              ) : (
                <>
                  <AddItem
                    className={Styles.recommendationCard__button__addIcon}
                  />
                  <div
                    className={`${Styles.recommendationCard__buttonText} ${Styles["recommendationCard__buttonText-default"]}`}
                  >
                    <LocaleText>
                      page.recommendationStep.selectButton.notSelected
                    </LocaleText>
                  </div>
                </>
              )}
            </Button>
          </div>
        ) : undefined}
      </div>
    </div>
  );
};

export default RecommendationCard;
